<div class="layoutBlock">
    <div class="columnThreeQuarter">

        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>
        
        <res-research-tab
        	[(projects)]="publication.projects"
            [showFundingPrograms]="true"
        	[dynamicComponent]="publication._dynamicComponent"
        	[dDKeyProject]="'fs.res.publication.Publication.projects'"
            [(fundingPrograms)]="publication.fundingPrograms"
             [(researchInfrastructures)]="publication.researchInfrastructures"
            [dDKeyResearchInfrastructures]="'fs.res.researchInfrastructure.ResearchInfrastructures'"
            (onBeforeNavigate)="onBeforeNavigate()"
            >
        </res-research-tab>
         
        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>       
        
        <res-funding-program-panel
            [editMode]="true"
            [projects]="publication.projects"
            [(fundingPrograms)]="publication.fundingPrograms">
        </res-funding-program-panel>
        
        <!-- #anchor dynamic field container -->
        <ng-template #dynamicFieldSetContainer></ng-template>

    </div>
</div>